import { createContext, useState, useEffect } from "react";

const UserContext = createContext({
  user: null,
  setUser: () => {}
});

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem("user");
    try {
      // Khởi tạo user với object mặc định nếu cần
      return savedUser ? JSON.parse(savedUser) : null;
    } catch (e) {
      return null;
    }
  });

  useEffect(() => {
    if (user) {
      localStorage.setItem("user", JSON.stringify(user));
      
      // Lưu userId và token riêng để axiosClient dễ gọi
      if (user.id || user.userId) {
        localStorage.setItem("userId", user.id || user.userId);
      }
      if (user.token) {
        localStorage.setItem("token", user.token);
      }
    } else {
      // Logout dọn dẹp sạch sẽ
      localStorage.removeItem("user");
      localStorage.removeItem("userId");
      localStorage.removeItem("token");
      localStorage.removeItem("workStartTime");
    }
  }, [user]);

  // CÁI NÀY LÀ MẸO HAY: Hàm updatePermissions để layout tự render lại menu khi save quyền mới
  const updateUserPermissions = (newPermissions) => {
    setUser(prev => ({ ...prev, permissions: newPermissions }));
  };

  return (
    <UserContext.Provider value={{ user, setUser, updateUserPermissions }}>
      {children}
    </UserContext.Provider>
  );
};

export default UserContext;